import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Dashboard from '@/pages/Home'
import Store from '../store/store'
import PlotRoutes from '@/pages/plot/routes'
import RumourRoutes from '@/pages/rumour/routes'
import LammieRoutes from '@/pages/lammie/routes'
import MonsterRoutes from '@/pages/monster/routes'
import EncounterRoutes from '@/pages/encounter/routes'
import ResearchRoutes from '@/pages/research/routes'
import ResearchPreiodRoutes from '@/pages/researchPeriod/routes'
import RitualCircleRoutes from '@/pages/ritualCircles/routes'
import UserRoutes from '@/pages/user/routes'
import UserProfileRoutes from '@/pages/userProfile/routes'
import RoleRoutes from '@/pages/rolesAndPermissions/routes'
import TeamRoutes from '@/pages/teams/routes'
import EventRoutes from '@/pages/event/routes'
import TagRoutes from '@/pages/entityTags/routes'
import EventTimetableRoutes from '@/pages/eventTimetable/routes'
import SystemPageRoutes from '@/pages/systemPage/routes'

Vue.use(VueRouter)

const baseRoutes = [
    {
        path: '/',
        name: 'Home',
        component: Dashboard,
        meta: { breadCrumb: '', entity: '' },
    },
    {
        path: '/forbidden',
        name: 'forbidden',
        component: () => import('@/pages/403.vue'),
    },
    {
        path: '/timetable',
        name: 'timetable',
        component: Home,
        meta: { breadCrumb: 'Timetables', entity: 'eventSlots' },
    },
    {
        path: '/about',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
        meta: { breadCrumb: 'About' },
    },
]

const routes = [
    ...baseRoutes,
    ...PlotRoutes,
    ...RumourRoutes,
    ...LammieRoutes,
    ...MonsterRoutes,
    ...EncounterRoutes,
    ...ResearchRoutes,
    ...UserRoutes,
    ...RoleRoutes,
    ...TeamRoutes,
    ...EventRoutes,
    ...EventTimetableRoutes,
    ...ResearchPreiodRoutes,
    ...RitualCircleRoutes,
    ...UserProfileRoutes,
    ...TagRoutes,
    ...SystemPageRoutes,
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
})

router.beforeEach((to, from, next) => {
    if (Store.getters.isInitiliazing) {
        next()
    } else {
        if (!Store.getters.isAuthenticated) {
            next('/unauthenticated')
        } else {
            let rootMeta = to.matched[0].meta
            if (rootMeta && rootMeta.entity && !Store.getters.hasAnyEntityPermission(rootMeta.entity)) {
                next('/forbidden')
            } else if (rootMeta && rootMeta.adminOnly && !Store.getters.isAdmin) {
                next('/forbidden')
            } else {
                next()
            }
        }
    }
})

export default router
